import { render, staticRenderFns } from "./kw_list_comment.vue?vue&type=template&id=ebfd7520&scoped=true&"
import script from "./kw_list_comment.vue?vue&type=script&lang=js&"
export * from "./kw_list_comment.vue?vue&type=script&lang=js&"
import style0 from "./kw_list_comment.vue?vue&type=style&index=0&id=ebfd7520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfd7520",
  null
  
)

component.options.__file = "kw_list_comment.vue"
export default component.exports